import { render, staticRenderFns } from "./ButtonAddCdp.vue?vue&type=template&id=089c0b48&"
import script from "./ButtonAddCdp.vue?vue&type=script&lang=ts&"
export * from "./ButtonAddCdp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports